import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TournamentService {

  constructor(
    private http: HttpClient,
  ) { }

  getSeasons(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + '/api/v1/season/list', { withCredentials: true });
  }

  createSeason(item): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + '/api/v1/season/create', JSON.stringify(item), { withCredentials: true });
  }

  getLeagues(season_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/season/${season_uuid}/league/list`, { withCredentials: true });
  }

  getLeagueGames(league_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/games`, { withCredentials: true });
  }

  getLeaguePlayers(league_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/players`, { withCredentials: true });
  }

  getLeagueScorers(league_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/scorers`, { withCredentials: true });
  }

  getLeagueDetails(league_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/info`, { withCredentials: true });
  }

  getTournamentBracket(season_uuid): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + `/api/v1/league/${season_uuid}/brackets`, { withCredentials: true });
  }

  createSeasonLeague(item): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/season/${item?.seasonId}/league/create`, JSON.stringify(item), { withCredentials: true });
  }

  updateSeasonLeague(item): Observable<any> {
    return this.http
    .put<any>(environment.apiUrl + `/api/v1/league/${item?.leagueId}/update`, JSON.stringify(item), { withCredentials: true });
  }

  scorerJoinLeague(league_uuid, scorer_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/scorers/${scorer_uuid}/join`, '', { withCredentials: true });
  }

  playerJoinLeague(league_uuid, player_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/players/${player_uuid}/join`, '', { withCredentials: true });
  }

  
  assignSeeds(league_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/assign-seeds`, '',{ withCredentials: true });
  }

  generateMatchups(league_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/generate-matchups`, '', { withCredentials: true });
  }
  
  startLeagueTournament(league_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/start-tournament`, '', { withCredentials: true });
  }
  
  generateNextRound(league_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/generate-next-round-matchups`, '', { withCredentials: true });
  }
  
  completeLeagueTournament(league_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/league/${league_uuid}/complete-league`, '', { withCredentials: true });
  }
}
